const SHOW_MODAL = 'modal/SHOW';
const HIDE_MODAL = 'modal/HIDE';

const initialState = {
  modalProps: {},
  modalType: ''
};

export const openModal = ({ modalType, modalProps }) => {
  return { type: SHOW_MODAL, modalType, modalProps };
};

export const hideModal = () => ({ type: HIDE_MODAL });

export const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return { modalType: action.modalType, modalProps: action.modalProps };

    case HIDE_MODAL:
      return initialState;

    default:
      return state;
  }
};

export default modalReducer;



// WEBPACK FOOTER //
// ./src/common/jsx/elements/modals/Modal/ducks.js